import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { CmsComponentsBaseModule } from '../../cms-components-base.module'
import { LinkModule } from '../link/link.module'
import { CallToActionButtonComponent } from './call-to-action-button.component'

@NgModule({
  declarations: [
    CallToActionButtonComponent
  ],
  imports: [
    CmsComponentsBaseModule,
    RouterModule,
    LinkModule
  ],
  exports: [
    CallToActionButtonComponent
  ]
})
export class CallToActionButtonModule {
}
